import { CookiesPolicyAgreementCard } from '@sravni/react-cookies-policy';
import { useIsMobile } from '@sravni/react-utils';

import { useAppSelector } from 'shared/lib';

import {
  selectIsFullDealPage,
  selectIsLoansLandingPage,
  selectIsMarketplaceSeoPage,
  selectIsVitrinsPage,
} from 'entities/siteSettings';
import { isWLSelector } from 'entities/whiteLabels';

import { MainPageFooter } from 'widgets/Footer';
import { MainSiteHeader } from 'widgets/Header';

/** Отвечает за показ хедера и футера */
export const PageWrapper: FC = ({ children }) => {
  const isMobile = useIsMobile();

  const isWl = useAppSelector(isWLSelector);
  const isFullDealPage = useAppSelector(selectIsFullDealPage);
  const isVitrinsPage = useAppSelector(selectIsVitrinsPage);
  const isLoansLandingPage = useAppSelector(selectIsLoansLandingPage);
  const isMarketplaceSeoPage = useAppSelector(selectIsMarketplaceSeoPage);
  const isShowHeader = !isWl;
  const isShowFooter = !(isWl || isFullDealPage);
  const isEnableCookiePolicy = !isWl;

  const isVitrinsHeader = isVitrinsPage || isMarketplaceSeoPage;

  return (
    <>
      {isShowHeader && <MainSiteHeader fixedBackground={isVitrinsHeader} />}

      {children}

      {isShowFooter && <MainPageFooter variant={isLoansLandingPage ? 'secondary' : 'primary'} />}

      {isEnableCookiePolicy && (
        <CookiesPolicyAgreementCard
          companyName="sravni"
          placement={isMobile ? 'top' : 'bottom-start'}
        />
      )}
    </>
  );
};
